export default "__VITE_ASSET__060efb93__"